export const DEFAULT_INVOICE_SUBJECT = 'Este es tu ahorro calculado';

export function validInvoiceSubject(value) {
    return typeof value === 'string' && value.trim().length > 0 && value.trim().length <= 200 && !/\p{Cc}/u.test(value);
}

export function validInvoiceEmail(value) {
    if (typeof value !== 'string' || value.length > 254 || /\s/.test(value) || value.split('@').length !== 2) return false;
    const [local, domain] = value.split('@');
    if (!local.length || local.length > 64 || local.startsWith('.') || local.endsWith('.') || local.includes('..')
        || !/^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+$/.test(local)) return false;
    const labels = domain.split('.');
    return labels.length >= 2 && !/^\d+$/.test(labels[labels.length - 1])
        && labels.every(label => /^[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?$/.test(label));
}

export function emailRequestId() {
    if (crypto.randomUUID) return crypto.randomUUID();
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
